//Core lib
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';

import { NgSelectModule } from '@ng-select/ng-select';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { NgxPaginationModule } from 'ngx-pagination';
import { CKEditorModule } from 'ngx-ckeditor';
import { GravatarModule } from 'ngx-gravatar';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DragulaModule } from 'ng2-dragula';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { CurrencyMaskConfig, CURRENCY_MASK_CONFIG } from 'ngx-currency-mask/src/currency-mask.config';

import { TruncatePipe } from '../shared/truncate.pipe';
import { NavTimeDirective } from '../shared/directives/itemNav.directive';
import { NoResultComponent } from '../shared/components/noresult';
import {CharacterCountComponent} from './components/character-count/character.count'

import { UploadComponent } from '../header/header-component/upload/upload.component';
import { SpinneerComponent } from '../utils/loader';
import { CommonDeleteModalComponent } from '../common/modals/common-delete-modal/common-delete';
import { CommonDocumentWarningComponent } from '../common/modals/common-document-warning-modal/common-document-warning-modal.component';

import { LocalToUTcPipe } from './pipe/local-to-utc.pipe';
import { UtcToLocalPipe } from './pipe/utc-to-local.pipe';
import { SearchBoxFilter } from './pipe/arrray-filter';

import { Debounce } from './directives/debounce.directive';


export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: "right",
    allowNegative: true,
    allowZero: true,
    decimal: ",",
    precision: 2,
    prefix: "$ ",
    suffix: "",
    thousands: "."
};

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgxPaginationModule,
        FilterPipeModule,
        NgSelectModule,
        DragulaModule.forRoot(),
        MDBBootstrapModulesPro.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        GravatarModule,
        CKEditorModule,
        InfiniteScrollModule,
    ],
    providers: [
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
    ],
    declarations: [
        Debounce,
        NoResultComponent,
        SpinneerComponent,
        NavTimeDirective,
        TruncatePipe,
        //header components
        UploadComponent,
        //common modals
        CommonDeleteModalComponent,
        CommonDocumentWarningComponent,
        CharacterCountComponent,
        LocalToUTcPipe,
        UtcToLocalPipe,
        SearchBoxFilter
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        TranslateModule,
        MDBBootstrapModulesPro,
        NgSelectModule,
        DragulaModule,
        NgxPaginationModule,
        FilterPipeModule,
        NoResultComponent,
        SpinneerComponent,
        NavTimeDirective,
        TruncatePipe,
        Debounce,
        //header components
        UploadComponent,
        //common modals
        CommonDeleteModalComponent,
        CommonDocumentWarningComponent,
        GravatarModule,
        CKEditorModule,
        CharacterCountComponent,
        InfiniteScrollModule,
        LocalToUTcPipe,
        UtcToLocalPipe,
        SearchBoxFilter
    ]
})
export class SharedModule {
    constructor(private translate: TranslateService) {
        const userSettingsJson = localStorage.getItem("userSettingsJson");
        const lang = userSettingsJson ? JSON.parse(userSettingsJson).preferredLanguageCode : 'en';
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('en');

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use(lang).subscribe(res=>{},
            err=>{
                this.translate.use("en")
                const userSettings = { preferredLanguageCode: 'en'};
                localStorage.setItem("userSettingsJson", JSON.stringify(userSettings));
            });

    }
}

